import store from "store2";
import { getLogin } from "@/libs/auth";

/**  水印添加方法  */
let setWatermark = str1 => {
  let id = "1.23452384164.123412415";
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }
  let can = document.createElement("canvas");
  // 设置canvas画布大小
  can.width = 400;
  can.height = 200;
  let cans = can.getContext("2d");
  cans.rotate(-20 * Math.PI / 180); // 水印旋转角度
  cans.font = "18px Vedana";
  // 水印通过 canvas 文字和覆盖层透明度共同控制深浅，避免干扰页面内容阅读。
  cans.fillStyle = "#999999";
  cans.textAlign = "center";
  cans.textBaseline = "Middle";
  cans.fillText(str1, can.width / 2, can.height); // 水印在画布的位置x，y轴
  // cans.fillText(str2, can.width / 2, can.height + 22);

  let div = document.createElement("div");
  div.id = id;
  div.style.pointerEvents = "none";
  div.style.top = "40px";
  div.style.left = "0px";
  div.style.opacity = "0.08";
  div.style.position = "fixed";
  div.style.zIndex = "100000";
  div.style.width = document.documentElement.clientWidth + "px";
  div.style.height = document.documentElement.clientHeight + "px";
  div.style.background = "url(" + can.toDataURL("image/png") + ") left top repeat";
  document.body.appendChild(div);
  return id;
};

// 添加水印方法
export const setWaterMark = str1 => {
  let id = setWatermark(str1);
  if (document.getElementById(id) === null) {
    id = setWatermark(str1);
  }
};

// 移除水印方法
export const removeWatermark = () => {
  let id = "1.23452384164.123412415";
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }
};

// 只要登录就显示水印
export const findRouterForPath = () => {
  let isLogin = getLogin();
  if (isLogin) {
    let user = store.get("userInfo");
    // 默认显示当前登录用户昵称跟手机号
    user && setWaterMark(`${user.userName}:${user.mobile}`);
  } else {
    removeWatermark();
  }
};